import React, { useState, useEffect } from 'react';
import api from '../api';
import LogoIcon from "../assets/logo.svg";
import { ShoppingCart, MessageSquare, Zap, Shield, Sparkles, Check, ArrowRight, ArrowLeftRight, Activity, Link, Send, Handshake, ShoppingBag, Store, Package, Star, X, Megaphone } from 'lucide-react';
import Avatar1 from "../assets/avatars/avatar1.png";
import Avatar2 from "../assets/avatars/avatar2.png";
import Avatar3 from "../assets/avatars/avatar3.png";
import Avatar4 from "../assets/avatars/avatar4.png";
import Avatar5 from "../assets/avatars/avatar5.png";
import Avatar6 from "../assets/avatars/avatar6.png";

const WhatsappIcon = ({ size, color }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={color}>
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
);

const TelegramIcon = ({ size, color }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={color}>
        <path d="m20.665 3.717-17.73 6.837c-1.21.486-1.203 1.161-.222 1.462l4.552 1.42 10.532-6.645c.498-.303.953-.14.579.192l-8.533 7.701h-.002l.002.001-.314 4.692c.46 0 .663-.211.921-.46l2.211-2.15 4.599 3.397c.848.467 1.457.227 1.668-.785l3.019-14.228c.309-1.239-.473-1.8-1.282-1.434z" />
    </svg>
);

const InstagramIcon = ({ size, color }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
);

const LandingPage = ({ onNavigateAuth }) => {
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [currentTestimonialPage, setCurrentTestimonialPage] = useState(0);
    const [planCategory, setPlanCategory] = useState('afiliados'); // 'afiliados' | 'divulgadores'
    const [prices, setPrices] = useState({
        priceBasic: 49.90,
        pricePremium: 99.90,
        priceDivulgadorBasic: 39.90,
        priceDivulgadorPremium: 79.90
    });

    useEffect(() => {
        const fetchPublicConfig = async () => {
            try {
                const res = await api.get('/auth/public-config');
                if (res.data) {
                    if (res.data.landingWhatsappNumber) {
                        setWhatsappNumber(res.data.landingWhatsappNumber);
                    }
                    if (res.data.priceBasic !== undefined) {
                        setPrices({
                            priceBasic: parseFloat(res.data.priceBasic) || 49.90,
                            pricePremium: parseFloat(res.data.pricePremium) || 99.90,
                            priceDivulgadorBasic: parseFloat(res.data.priceDivulgadorBasic) || 39.90,
                            priceDivulgadorPremium: parseFloat(res.data.priceDivulgadorPremium) || 79.90
                        });
                    }
                }
            } catch (err) {
                console.error("Erro ao carregar contato do WhatsApp ou configurações públicas:", err);
            }
        };
        fetchPublicConfig();
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div style={{ fontFamily: 'Outfit, sans-serif', backgroundColor: '#f8fafc', color: '#0f172a', minHeight: '100vh', overflowX: 'hidden' }}>

            {/* MENU SUPERIOR (NAVBAR) */}
            <nav className="landing-nav" style={{
                position: 'sticky', top: 0, left: 0, right: 0, zIndex: 100,
                backgroundColor: 'rgba(30, 41, 59, 0.95)', backdropFilter: 'blur(12px)',
                borderBottom: '1px solid #334155', padding: '10px 30px',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '16px', fontWeight: '800', color: '#FD5B1F', gap: '4px', letterSpacing: '-0.025em', userSelect: 'none', WebkitUserSelect: 'none', MozUserSelect: 'none', msUserSelect: 'none', cursor: 'default' }}>
                    <img src={LogoIcon} alt="Logo" style={{ width: '36px', height: '36px', objectFit: 'contain', aspectRatio: '1/1', flexShrink: 0, filter: 'drop-shadow(0.5px 0px 0px rgba(0, 0, 0, 0.15)) drop-shadow(-0.5px 0px 0px rgba(0, 0, 0, 0.15)) drop-shadow(0px 0.5px 0px rgba(0, 0, 0, 0.15)) drop-shadow(0px -0.5px 0px rgba(0, 0, 0, 0.15))', pointerEvents: 'none' }} />
                    <span>Anúncios App</span>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '30px', fontSize: '16px', fontWeight: '800' }} className="desktop-menu">
                    <button onClick={() => scrollToSection('como-funciona')} style={{ ...navLinkStyle, fontSize: '16px', fontWeight: '800', color: '#cbd5e1' }}>Como Funciona</button>
                    <button onClick={() => scrollToSection('recursos')} style={{ ...navLinkStyle, fontSize: '16px', fontWeight: '800', color: '#cbd5e1' }}>Recursos</button>
                    <button onClick={() => scrollToSection('depoimentos')} style={{ ...navLinkStyle, fontSize: '16px', fontWeight: '800', color: '#cbd5e1' }}>Depoimentos</button>
                    <button onClick={() => scrollToSection('planos')} style={{ ...navLinkStyle, fontSize: '16px', fontWeight: '800', color: '#cbd5e1' }}>Planos</button>
                </div>

                <div className="nav-auth-buttons" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <button
                        onClick={() => onNavigateAuth('login')}
                        className="nav-btn-login"
                        style={{
                            background: 'none', border: 'none', color: '#cbd5e1',
                            fontSize: '16px', fontWeight: '800', cursor: 'pointer', padding: '10px 15px'
                        }}
                    >
                        Entrar no Painel
                    </button>
                    <button
                        onClick={() => onNavigateAuth('register')}
                        className="nav-btn-register"
                        style={{
                            backgroundColor: '#ee4d2d', color: 'white', border: 'none',
                            borderRadius: '10px', padding: '10px 22px', fontSize: '16px',
                            fontWeight: '800', cursor: 'pointer', boxShadow: '0 4px 12px rgba(238, 77, 45, 0.2)',
                            transition: '0.2s'
                        }}
                    >
                        Criar Conta Grátis
                    </button>
                </div>
            </nav>

            {/* HERO SECTION */}
            <header style={{
                padding: '80px 20px max(100px, 10vw) 20px',
                background: 'linear-gradient(135deg, #fff5f1 0%, #ffffff 100%)',
                textAlign: 'center', position: 'relative'
            }}>
                {/* Efeitos de Luz Decorativos */}
                <div style={{ position: 'absolute', top: '10%', left: '10%', width: '150px', height: '150px', background: '#ffe4e6', filter: 'blur(100px)', borderRadius: '50%', zIndex: 0 }} />
                <div style={{ position: 'absolute', bottom: '15%', right: '10%', width: '200px', height: '200px', background: '#fff5f1', filter: 'blur(100px)', borderRadius: '50%', zIndex: 0 }} />

                <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
                    {/* Badge Destaque */}
                    <div style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                        backgroundColor: '#fff1f0', border: '1px solid #ffe4e6', borderRadius: '20px',
                        padding: '6px 16px', marginBottom: '25px'
                    }}>
                        <Sparkles size={14} color="#ee4d2d" />
                        <span style={{ fontSize: '12px', fontWeight: '800', color: '#ee4d2d', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            O Melhor Divulgador Automático de Afiliados do Brasil
                        </span>
                    </div>

                    <h1 style={{
                        fontSize: 'max(36px, 4.5vw)', fontWeight: '900', color: '#0f172a',
                        lineHeight: '1.1', letterSpacing: '-0.03em', margin: '0 0 20px 0'
                    }}>
                        Fature como Afiliado no <span style={{ color: '#ee4d2d' }}>Piloto Automático!</span>
                    </h1>

                    <p style={{
                        fontSize: 'max(15px, 1.2vw)', color: '#475569', maxWidth: '700px',
                        margin: '0 auto 35px auto', lineHeight: '1.6'
                    }}>
                        O robô definitivo para afiliados Shopee, Mercado Livre, AliExpress, Amazon, Shein e Magazine Luiza. Encontre as melhores ofertas ou envie links manuais, converta e encurte com seu ID de Afiliado na hora, publique automaticamente em grupos do WhatsApp e canais do Telegram, e responda comentários e DMs do Instagram no Direct de forma 100% automática!
                    </p>

                    <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                        <button
                            onClick={() => onNavigateAuth('register')}
                            style={{
                                backgroundColor: '#ee4d2d', color: 'white', border: 'none',
                                borderRadius: '12px', padding: '16px 32px', fontSize: '16px',
                                fontWeight: '800', cursor: 'pointer', boxShadow: '0 10px 20px -5px rgba(238, 77, 45, 0.4)',
                                display: 'flex', alignItems: 'center', gap: '8px', transition: '0.2s'
                            }}
                        >
                            🚀 Experimentar Grátis <ArrowRight size={18} />
                        </button>
                        <button
                            onClick={() => scrollToSection('como-funciona')}
                            style={{
                                backgroundColor: 'white', color: '#1e293b', border: '1px solid #cbd5e1',
                                borderRadius: '12px', padding: '16px 32px', fontSize: '16px',
                                fontWeight: '800', cursor: 'pointer', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.02)',
                                transition: '0.2s'
                            }}
                        >
                            Saiba Mais
                        </button>
                    </div>
                </div>
            </header>

            {/* MOCKUP DO SISTEMA (VISUAL PREMIUM) */}
            <div style={{
                maxWidth: '960px', margin: '-80px auto 100px auto', padding: '0 20px',
                position: 'relative', zIndex: 2
            }}>
                <div style={{
                    backgroundColor: 'white', border: '8px solid #f1f5f9', borderRadius: '24px',
                    boxShadow: '0 25px 50px -12px rgba(0,0,0,0.15)', overflow: 'hidden'
                }}>
                    <div style={{
                        backgroundColor: '#f8fafc', padding: '12px 20px', borderBottom: '1px solid #e2e8f0',
                        display: 'flex', alignItems: 'center', gap: '8px'
                    }}>
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ef4444' }} />
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#eab308' }} />
                        <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#22c55e' }} />
                        <span style={{ fontSize: '12px', color: '#64748b', marginLeft: '10px', fontWeight: 'bold' }}>anunciosapp.shop/dashboard</span>
                    </div>

                    {/* Visual Simplificado do Painel em CSS */}
                    <div style={{ padding: '30px', backgroundColor: '#f8fafc', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>

                        {/* Header Mockup */}
                        <div style={{ width: '100%', maxWidth: '700px', display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                            <span style={{ fontSize: '24px' }}>📊</span>
                            <h2 style={{ margin: 0, fontSize: '22px', fontWeight: '800', color: '#0f172a' }}>Visão Geral</h2>
                        </div>

                        {/* Server Online Status */}
                        <div style={{
                            width: '100%', maxWidth: '700px', backgroundColor: 'white', borderRadius: '12px',
                            border: '1px solid #e2e8f0', borderLeft: '4px solid #22c55e', padding: '15px 20px',
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.02)'
                        }}>
                            <div>
                                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase', marginBottom: '4px' }}>Server</div>
                                <div style={{ fontSize: '16px', fontWeight: '800', color: '#0f172a' }}>Online</div>
                            </div>
                            <Activity size={20} color="#22c55e" />
                        </div>

                        {/* Toggles Card */}
                        <div style={{
                            width: '100%', maxWidth: '700px', backgroundColor: 'white', borderRadius: '16px',
                            border: '1px solid #e2e8f0', padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
                        }}>
                            {/* WhatsApp */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    <div style={{ width: '36px', height: '36px', backgroundColor: '#25D366', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <WhatsappIcon size={20} color="white" />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b' }}>Publicar no Whatsapp</div>
                                        <div style={{ fontSize: '12px', color: '#64748b' }}>Posta no seu WhatsApp pessoal configurado</div>
                                    </div>
                                </div>
                                <div style={{ width: '44px', height: '24px', backgroundColor: '#25D366', borderRadius: '12px', position: 'relative' }}>
                                    <div style={{ width: '18px', height: '18px', backgroundColor: 'white', borderRadius: '50%', position: 'absolute', top: '3px', right: '3px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                                </div>
                            </div>

                            <div style={{ height: '1px', backgroundColor: '#e2e8f0' }} />

                            {/* Telegram */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    <div style={{ width: '36px', height: '36px', backgroundColor: '#0088cc', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <TelegramIcon size={18} color="white" />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b' }}>Publicar no Telegram</div>
                                        <div style={{ fontSize: '12px', color: '#64748b' }}>Posta no seu bot ou canal do Telegram configurado</div>
                                    </div>
                                </div>
                                <div style={{ width: '44px', height: '24px', backgroundColor: '#0088cc', borderRadius: '12px', position: 'relative' }}>
                                    <div style={{ width: '18px', height: '18px', backgroundColor: 'white', borderRadius: '50%', position: 'absolute', top: '3px', right: '3px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                                </div>
                            </div>

                            <div style={{ height: '1px', backgroundColor: '#e2e8f0' }} />

                            {/* Instagram */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    <div style={{ width: '36px', height: '36px', backgroundColor: '#e1306c', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <InstagramIcon size={20} color="white" />
                                    </div>
                                    <div>
                                        <div style={{ fontSize: '14px', fontWeight: '700', color: '#1e293b' }}>Publicar no instagram</div>
                                        <div style={{ fontSize: '12px', color: '#64748b' }}>Posta no Feed e nos Stories automáticos</div>
                                    </div>
                                </div>
                                <div style={{ width: '44px', height: '24px', backgroundColor: '#e1306c', borderRadius: '12px', position: 'relative' }}>
                                    <div style={{ width: '18px', height: '18px', backgroundColor: 'white', borderRadius: '50%', position: 'absolute', top: '3px', right: '3px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                                </div>
                            </div>
                        </div>

                        {/* Disparo em Massa Mockup */}
                        <div style={{
                            width: '100%', maxWidth: '700px', backgroundColor: 'white', borderRadius: '16px',
                            border: '2px dashed #e2e8f0', padding: '30px', textAlign: 'center',
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px'
                        }}>
                            <div>
                                <h3 style={{ margin: '0 0 10px 0', fontSize: '18px', color: '#1e293b' }}>🚀 Disparo em Massa</h3>
                                <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>Marque as plataformas e dispare para seus canais configurados:</p>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                <div style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', fontWeight: '600', color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <ShoppingBag size={14} color="#ee4d2d" /> Shopee
                                </div>
                                <div style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', fontWeight: '600', color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Store size={14} color="#0086ff" /> Magalu
                                </div>
                                <div style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', fontWeight: '600', color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Package size={14} color="#ff4747" /> AliExpress
                                </div>
                                <div style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', fontWeight: '600', color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <Handshake size={14} color="#2d3277" /> Mercado Livre
                                </div>
                                <div style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', fontWeight: '600', color: '#475569', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <ShoppingCart size={14} color="#ff9900" /> Amazon
                                </div>
                            </div>
                            <div style={{ width: '100%', maxWidth: '400px', padding: '16px', backgroundColor: '#22c55e', color: 'white', borderRadius: '12px', fontWeight: '800', fontSize: '14px', boxShadow: '0 10px 20px -5px rgba(34, 197, 94, 0.4)' }}>
                                ▶ EXECUTAR DISPARO SELECIONADO
                            </div>
                        </div>

                        {/* Publicação Personalizada Mockup */}
                        <div style={{
                            width: '100%', maxWidth: '700px', backgroundColor: 'white', borderRadius: '16px',
                            border: '2px dashed #e2e8f0', padding: '30px', textAlign: 'center',
                            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px'
                        }}>
                            <div>
                                <h3 style={{ margin: '0 0 10px 0', fontSize: '18px', color: '#1e293b', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    <Link size={18} color="#ee4d2d" /> Publicação Personalizada
                                </h3>
                                <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>Cole o link do produto para enviar agora:</p>
                            </div>

                            <div style={{ width: '100%', maxWidth: '500px', padding: '12px 16px', borderRadius: '8px', border: '1px solid #cbd5e1', textAlign: 'left', color: '#94a3b8', fontSize: '14px' }}>
                                Ex: https://amzn.to/... ou shopee...
                            </div>

                            <div style={{ width: '100%', maxWidth: '500px', padding: '16px', backgroundColor: '#ee4d2d', color: 'white', borderRadius: '12px', fontWeight: '800', fontSize: '14px', boxShadow: '0 10px 20px -5px rgba(238, 77, 45, 0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                                <Send size={16} /> ENVIAR OFERTA MANUAL
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* SEÇÃO: COMO FUNCIONA */}
            <section id="como-funciona" style={{ padding: '80px 20px', backgroundColor: 'white' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a', margin: '0 0 10px 0' }}>
                            Como o Robô Multiplica suas Vendas?
                        </h2>
                        <p style={{ color: '#64748b', fontSize: '16px', maxWidth: '600px', margin: '0 auto' }}>
                            Um fluxo 100% integrado que atua desde a busca de produtos até o atendimento ao cliente e conversão de links.
                        </p>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '30px' }}>
                        <div style={stepCardStyle}>
                            <div style={{ ...iconBgStyle, backgroundColor: '#fff5f1', color: '#ee4d2d' }}>
                                <ArrowLeftRight size={24} />
                            </div>
                            <h3 style={stepTitleStyle}>1. Conversão e Encurtamento</h3>
                            <p style={stepTextStyle}>
                                O bot captura qualquer link comum de promoção da Shopee, Mercado Livre, AliExpress, Amazon, Shein ou Magazine Luiza (Magalu) e converte instantaneamente para o seu link com seu ID de Afiliado.
                            </p>
                        </div>

                        <div style={stepCardStyle}>
                            <div style={{ ...iconBgStyle, backgroundColor: '#f0fdf4', color: '#16a34a' }}>
                                <Zap size={24} />
                            </div>
                            <h3 style={stepTitleStyle}>2. Disparo Multicanal</h3>
                            <p style={stepTextStyle}>
                                Agenda e envia as ofertas automaticamente para centenas de canais e grupos de ofertas do WhatsApp (suportando múltiplas instâncias) e do Telegram com delays inteligentes anti-ban.
                            </p>
                        </div>

                        <div style={stepCardStyle}>
                            <div style={{ ...iconBgStyle, backgroundColor: '#fdf2f8', color: '#e1306c' }}>
                                <InstagramIcon size={24} color="#e1306c" />
                            </div>
                            <h3 style={stepTitleStyle}>3. Automação do Instagram</h3>
                            <p style={stepTextStyle}>
                                Seus seguidores comentam em seus posts e reels. O robô detecta em tempo real, envia a oferta diretamente no Direct, e responde ao comentário público marcando a pessoa!
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* SEÇÃO: RECURSOS */}
            <section id="recursos" style={{ padding: '80px 20px', backgroundColor: '#f8fafc' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <span style={{ color: '#ee4d2d', fontWeight: '800', fontSize: '13px', textTransform: 'uppercase', tracking: '0.05em' }}>TECNOLOGIA EXCLUSIVA</span>
                        <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a', margin: '10px 0 0 0' }}>
                            Tudo que você precisa para escalar
                        </h2>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
                        <div style={featureCardStyle}>
                            <Shield size={24} style={{ color: '#22c55e', marginBottom: '15px' }} />
                            <h4 style={{ fontSize: '18px', fontWeight: '800', margin: '0 0 8px 0', color: '#0f172a' }}>Anti-Ban Integrado</h4>
                            <p style={{ fontSize: '14px', color: '#64748b', margin: 0, lineHeight: '1.5' }}>
                                Algoritmos inteligentes que simulam o comportamento humano com delays customizados para proteger sua conta do WhatsApp.
                            </p>
                        </div>

                        <div style={featureCardStyle}>
                            <Send size={24} style={{ color: '#0088cc', marginBottom: '15px' }} />
                            <h4 style={{ fontSize: '18px', fontWeight: '800', margin: '0 0 8px 0', color: '#0f172a' }}>Automação Multi-Canal</h4>
                            <p style={{ fontSize: '14px', color: '#64748b', margin: 0, lineHeight: '1.5' }}>
                                Dispare suas ofertas simultaneamente no WhatsApp e Telegram, alcançando muito mais clientes com apenas um clique.
                            </p>
                        </div>

                        <div style={featureCardStyle}>
                            <MessageSquare size={24} style={{ color: '#e1306c', marginBottom: '15px' }} />
                            <h4 style={{ fontSize: '18px', fontWeight: '800', margin: '0 0 8px 0', color: '#0f172a' }}>Integração Oficial Meta</h4>
                            <p style={{ fontSize: '14px', color: '#64748b', margin: 0, lineHeight: '1.5' }}>
                                Responda comentários automaticamente com o link do produto no direct dos seus seguidores. Conexão 100% segura e aprovada.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* SEÇÃO: DEPOIMENTOS */}
            <section id="depoimentos" style={{ padding: '80px 20px', backgroundColor: 'white' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <span style={{ color: '#ee4d2d', fontWeight: '800', fontSize: '13px', textTransform: 'uppercase', tracking: '0.05em' }}>CASOS DE SUCESSO</span>
                        <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a', margin: '10px 0 0 0' }}>
                            O que nossos usuários dizem
                        </h2>
                    </div>

                    <div style={{ overflow: 'hidden', width: '100%', paddingBottom: '20px' }}>
                        <div style={{
                            display: 'flex',
                            width: '200%',
                            transform: `translateX(-${currentTestimonialPage * 50}%)`,
                            transition: 'transform 0.5s ease-in-out'
                        }}>
                            {/* Page 0 */}
                            <div style={{ width: '50%', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', padding: '0 10px' }}>
                                {/* Review 1 */}
                                <div style={reviewCardStyle}>
                                    <div style={{ display: 'flex', gap: '4px', marginBottom: '15px' }}>
                                        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#eab308" color="#eab308" />)}
                                    </div>
                                    <p style={{ fontSize: '15px', color: '#475569', lineHeight: '1.6', marginBottom: '20px', fontStyle: 'italic' }}>
                                        "Minhas comissões da Shopee triplicaram desde que comecei a usar o bot. Deixar ele respondendo os directs do Instagram enquanto eu durmo foi a melhor decisão pro meu negócio!"
                                    </p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                            <img src={Avatar1} alt="Marcos" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div>
                                            <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Marcos S.</h4>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>Afiliado Shopee & AliExpress</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Review 2 */}
                                <div style={reviewCardStyle}>
                                    <div style={{ display: 'flex', gap: '4px', marginBottom: '15px' }}>
                                        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#eab308" color="#eab308" />)}
                                    </div>
                                    <p style={{ fontSize: '15px', color: '#475569', lineHeight: '1.6', marginBottom: '20px', fontStyle: 'italic' }}>
                                        "Eu perdia horas convertendo links e enviando nos meus 5 grupos de ofertas. Agora eu colo o link original e o Anúncios App dispara em todos de uma vez. Surreal de bom."
                                    </p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                            <img src={Avatar2} alt="Juliana" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div>
                                            <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Juliana F.</h4>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>Influenciadora de Achadinhos</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Review 3 */}
                                <div style={reviewCardStyle}>
                                    <div style={{ display: 'flex', gap: '4px', marginBottom: '15px' }}>
                                        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#eab308" color="#eab308" />)}
                                    </div>
                                    <p style={{ fontSize: '15px', color: '#475569', lineHeight: '1.6', marginBottom: '20px', fontStyle: 'italic' }}>
                                        "O anti-ban do WhatsApp é perfeito. Estou usando a automação há 2 meses disparando o dia todo e zero problemas. O suporte também é excelente!"
                                    </p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                            <img src={Avatar3} alt="Rafael" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div>
                                            <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Rafael T.</h4>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>Personal Trainer</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Page 1 */}
                            <div style={{ width: '50%', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', padding: '0 10px' }}>
                                {/* Review 4 */}
                                <div style={reviewCardStyle}>
                                    <div style={{ display: 'flex', gap: '4px', marginBottom: '15px' }}>
                                        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#eab308" color="#eab308" />)}
                                    </div>
                                    <p style={{ fontSize: '15px', color: '#475569', lineHeight: '1.6', marginBottom: '20px', fontStyle: 'italic' }}>
                                        "Comecei do zero e a ferramenta fez tudo por mim. Minhas vendas na Amazon aumentaram demais graças às automações no Telegram!"
                                    </p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                            <img src={Avatar4} alt="Amanda" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div>
                                            <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Amanda R.</h4>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>Afiliada Amazon e Magalu</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Review 5 */}
                                <div style={reviewCardStyle}>
                                    <div style={{ display: 'flex', gap: '4px', marginBottom: '15px' }}>
                                        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#eab308" color="#eab308" />)}
                                    </div>
                                    <p style={{ fontSize: '15px', color: '#475569', lineHeight: '1.6', marginBottom: '20px', fontStyle: 'italic' }}>
                                        "Eu não tinha ideia de como gerenciar vários grupos no WhatsApp, até descobrir o Anúncios App. Mudou meu jogo completamente!"
                                    </p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                            <img src={Avatar5} alt="Eliane" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div>
                                            <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Eliane C.</h4>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>Dona de Casa e Afiliada</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Review 6 */}
                                <div style={reviewCardStyle}>
                                    <div style={{ display: 'flex', gap: '4px', marginBottom: '15px' }}>
                                        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#eab308" color="#eab308" />)}
                                    </div>
                                    <p style={{ fontSize: '15px', color: '#475569', lineHeight: '1.6', marginBottom: '20px', fontStyle: 'italic' }}>
                                        "Responder no Instagram estava consumindo todo o meu dia. Hoje o bot atende todo mundo em segundos, e a conversão de vendas é automática."
                                    </p>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                            <img src={Avatar6} alt="Diego" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div>
                                            <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>Diego M.</h4>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>Trabalhador Autônomo</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Dots Navigation */}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '15px' }}>
                        <button
                            onClick={() => setCurrentTestimonialPage(0)}
                            style={{ width: '12px', height: '12px', borderRadius: '50%', border: 'none', backgroundColor: currentTestimonialPage === 0 ? '#ee4d2d' : '#cbd5e1', cursor: 'pointer', padding: 0, transition: '0.3s' }}
                            aria-label="Página 1"
                        />
                        <button
                            onClick={() => setCurrentTestimonialPage(1)}
                            style={{ width: '12px', height: '12px', borderRadius: '50%', border: 'none', backgroundColor: currentTestimonialPage === 1 ? '#ee4d2d' : '#cbd5e1', cursor: 'pointer', padding: 0, transition: '0.3s' }}
                            aria-label="Página 2"
                        />
                    </div>
                </div>
            </section>

            {/* SEÇÃO: NOSSOS PLANOS */}
            <section id="planos" style={{ padding: '80px 20px', backgroundColor: 'white' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a', margin: '0 0 10px 0' }}>
                            Nossos Planos e Preços
                        </h2>
                        <p style={{ color: '#64748b', fontSize: '16px', maxWidth: '600px', margin: '0 auto' }}>
                            Sem contratos, sem taxas extras. Cancele ou mude de plano quando quiser através do Stripe seguro.
                        </p>
                    </div>

                    {/* SELETOR DE CATEGORIA: AFILIADOS X DIVULGADORES */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '45px' }}>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: '#f1f5f9',
                            padding: '6px',
                            borderRadius: '50px',
                            border: '1px solid #e2e8f0',
                            gap: '6px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}>
                            <button
                                type="button"
                                id="btn-tab-afiliados"
                                onClick={() => setPlanCategory('afiliados')}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '10px 26px',
                                    borderRadius: '40px',
                                    border: 'none',
                                    fontWeight: '800',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    transition: 'all 0.25s ease',
                                    backgroundColor: planCategory === 'afiliados' ? '#ee4d2d' : 'transparent',
                                    color: planCategory === 'afiliados' ? '#ffffff' : '#64748b',
                                    boxShadow: planCategory === 'afiliados' ? '0 4px 14px rgba(238, 77, 45, 0.3)' : 'none'
                                }}
                            >
                                <ShoppingCart size={18} />
                                <span>Afiliados</span>
                            </button>

                            <button
                                type="button"
                                id="btn-tab-divulgadores"
                                onClick={() => setPlanCategory('divulgadores')}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '10px 26px',
                                    borderRadius: '40px',
                                    border: 'none',
                                    fontWeight: '800',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    transition: 'all 0.25s ease',
                                    backgroundColor: planCategory === 'divulgadores' ? '#1e293b' : 'transparent',
                                    color: planCategory === 'divulgadores' ? '#ffffff' : '#64748b',
                                    boxShadow: planCategory === 'divulgadores' ? '0 4px 14px rgba(30, 41, 59, 0.3)' : 'none'
                                }}
                            >
                                <Megaphone size={18} />
                                <span>Divulgadores</span>
                            </button>
                        </div>

                        <p style={{
                            margin: '14px 0 0 0',
                            fontSize: '14px',
                            color: '#64748b',
                            fontWeight: '500',
                            textAlign: 'center',
                            maxWidth: '560px'
                        }}>
                            {planCategory === 'afiliados'
                                ? 'Para quem divulga ofertas e links comissionados da Shopee, Magalu, Amazon, Mercado Livre, etc.'
                                : 'Para quem divulga conteúdos próprios, postagens de texto, fotos e vídeos para múltiplos grupos.'}
                        </p>
                    </div>

                    {/* ========================================================================= */}
                    {/* GRID DE CARDS: AFILIADOS                                                  */}
                    {/* ========================================================================= */}
                    {planCategory === 'afiliados' ? (
                        <div key="afiliados" className="plans-animation" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px', alignItems: 'stretch' }}>

                            {/* CARD GRÁTIS */}
                            <div style={planCardStyle}>
                                <div>
                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', tracking: '0.05em', backgroundColor: '#f1f5f9', padding: '4px 10px', borderRadius: '8px' }}>
                                        Experimentar
                                    </span>
                                    <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', margin: '15px 0 5px 0' }}>Plano Free</h3>
                                    <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>Encurte e prepare suas ofertas manualmente.</p>

                                    <div style={{ margin: '25px 0', display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                        <span style={{ fontSize: '36px', fontWeight: '800', color: '#0f172a' }}>R$ 0</span>
                                        <span style={{ fontSize: '14px', color: '#64748b' }}>/mês</span>
                                    </div>

                                    <hr style={{ border: 0, borderTop: '1px solid #f1f5f9', margin: '20px 0' }} />

                                    <ul style={planListStyle}>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Encurtador manual de links</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Conversão com seu ID de afiliado</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Painel de métricas básicas</li>
                                        <li style={{ ...planListItemStyle, color: '#94a3b8', textDecoration: 'line-through' }}><X size={16} style={{ color: '#ef4444' }} /> Sem automações de disparos</li>
                                    </ul>
                                </div>

                                <button onClick={() => onNavigateAuth('register')} style={{ ...btnPlanStyle, backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}>
                                    Começar Grátis
                                </button>
                            </div>

                            {/* CARD BÁSICO */}
                            <div style={{ ...planCardStyle, border: '2px solid #ee4d2d', position: 'relative' }}>
                                <div style={{ position: 'absolute', top: '-11px', left: '20px', backgroundColor: '#ee4d2d', color: 'white', padding: '2px 10px', borderRadius: '8px', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase' }}>
                                    Recomendado
                                </div>
                                <div>
                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#ee4d2d', textTransform: 'uppercase', tracking: '0.05em', backgroundColor: '#fff5f1', padding: '4px 10px', borderRadius: '8px' }}>
                                        Crescimento
                                    </span>
                                    <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', margin: '15px 0 5px 0' }}>Plano Básico</h3>
                                    <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>Excelente para afiliados em crescimento.</p>

                                    <div style={{ margin: '25px 0', display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                        <span style={{ fontSize: '36px', fontWeight: '800', color: '#0f172a' }}>R$ {prices.priceBasic.toFixed(2).replace('.', ',')}</span>
                                        <span style={{ fontSize: '14px', color: '#64748b' }}>/mês</span>
                                    </div>

                                    <hr style={{ border: 0, borderTop: '1px solid #f1f5f9', margin: '20px 0' }} />

                                    <ul style={planListStyle}>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Encaminhamento p/ WhatsApp pessoal</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Integração com Bot do Telegram</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Encurtador de links automático</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Agendamento de posts 24h</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Envio de fotos e vídeos nos grupos</li>
                                    </ul>
                                </div>

                                <button onClick={() => onNavigateAuth('register')} style={{ ...btnPlanStyle, backgroundColor: '#ee4d2d', color: 'white' }}>
                                    Assinar Básico
                                </button>
                            </div>

                            {/* CARD PROFISSIONAL */}
                            <div style={{ ...planCardStyle, backgroundColor: '#1e293b', color: 'white', border: '1px solid #334155', position: 'relative' }}>
                                <div style={{ position: 'absolute', top: '-11px', left: '20px', backgroundColor: '#8b5cf6', color: 'white', padding: '2px 10px', borderRadius: '8px', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase' }}>
                                    Automação Total
                                </div>
                                <div>
                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#c084fc', textTransform: 'uppercase', tracking: '0.05em', backgroundColor: 'rgba(139,92,246,0.15)', padding: '4px 10px', borderRadius: '8px' }}>
                                        Supremo
                                    </span>
                                    <h3 style={{ fontSize: '24px', fontWeight: '800', color: 'white', margin: '15px 0 5px 0' }}>Plano Profissional</h3>
                                    <p style={{ fontSize: '13px', color: '#94a3b8', margin: 0 }}>A solução suprema para grandes afiliados.</p>

                                    <div style={{ margin: '25px 0', display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                        <span style={{ fontSize: '36px', fontWeight: '800', color: 'white' }}>R$ {prices.pricePremium.toFixed(2).replace('.', ',')}</span>
                                        <span style={{ fontSize: '14px', color: '#94a3b8' }}>/mês</span>
                                    </div>

                                    <hr style={{ border: 0, borderTop: '1px solid #334155', margin: '20px 0' }} />

                                    <ul style={planListStyle}>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> WhatsApp pessoal + Bot do Telegram</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> **Resposta Automática no Instagram**</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> **Automação de Comentários (Direct)**</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> **Suporte Prioritário VIP**</li>
                                    </ul>
                                </div>

                                <button onClick={() => onNavigateAuth('register')} style={{ ...btnPlanStyle, backgroundColor: '#8b5cf6', color: 'white' }}>
                                    Assinar Profissional
                                </button>
                            </div>

                        </div>
                    ) : (
                        /* ========================================================================= */
                        /* GRID DE CARDS: DIVULGADORES                                               */
                        /* ========================================================================= */
                        <div key="divulgadores" className="plans-animation" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px', alignItems: 'stretch' }}>

                            {/* 1. PLANO FREE (DIVULGADOR) */}
                            <div style={planCardStyle}>
                                <div>
                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', tracking: '0.05em', backgroundColor: '#f1f5f9', padding: '4px 10px', borderRadius: '8px' }}>
                                        Experimentar
                                    </span>
                                    <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', margin: '15px 0 5px 0' }}>Plano Free Divulgador</h3>
                                    <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>Envie textos para 1 grupo com intervalo.</p>

                                    <div style={{ margin: '25px 0', display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                        <span style={{ fontSize: '36px', fontWeight: '800', color: '#0f172a' }}>R$ 0</span>
                                        <span style={{ fontSize: '14px', color: '#64748b' }}>/mês</span>
                                    </div>

                                    <hr style={{ border: 0, borderTop: '1px solid #f1f5f9', margin: '20px 0' }} />

                                    <ul style={planListStyle}>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Postagens próprias de textos</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Envio para 1 grupo ativo</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Cooldown de 2h entre posts</li>
                                        <li style={{ ...planListItemStyle, color: '#94a3b8', textDecoration: 'line-through' }}><X size={16} style={{ color: '#ef4444' }} /> Sem envio de fotos e vídeos</li>
                                    </ul>
                                </div>

                                <button onClick={() => onNavigateAuth('register')} style={{ ...btnPlanStyle, backgroundColor: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}>
                                    Começar Grátis
                                </button>
                            </div>

                            {/* 2. PLANO BÁSICO (DIVULGADOR) */}
                            <div style={{ ...planCardStyle, border: '2px solid #3b82f6', position: 'relative' }}>
                                <div style={{ position: 'absolute', top: '-11px', left: '20px', backgroundColor: '#3b82f6', color: 'white', padding: '2px 10px', borderRadius: '8px', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase' }}>
                                    Grupos Ilimitados
                                </div>
                                <div>
                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#3b82f6', textTransform: 'uppercase', tracking: '0.05em', backgroundColor: '#eff6ff', padding: '4px 10px', borderRadius: '8px' }}>
                                        Divulgação
                                    </span>
                                    <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#0f172a', margin: '15px 0 5px 0' }}>Básico Divulgador</h3>
                                    <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>Excelente para lojas e comércios locais.</p>

                                    <div style={{ margin: '25px 0', display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                        <span style={{ fontSize: '36px', fontWeight: '800', color: '#0f172a' }}>R$ {prices.priceDivulgadorBasic.toFixed(2).replace('.', ',')}</span>
                                        <span style={{ fontSize: '14px', color: '#64748b' }}>/mês</span>
                                    </div>

                                    <hr style={{ border: 0, borderTop: '1px solid #f1f5f9', margin: '20px 0' }} />

                                    <ul style={planListStyle}>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Postagens próprias de textos</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Envio de fotos e vídeos nos grupos</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Envio para grupos ilimitados</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#22c55e' }} /> Sem limitações de horários</li>
                                    </ul>
                                </div>

                                <button onClick={() => onNavigateAuth('register')} style={{ ...btnPlanStyle, backgroundColor: '#3b82f6', color: 'white' }}>
                                    Assinar Básico
                                </button>
                            </div>

                            {/* 3. PLANO PROFISSIONAL (DIVULGADOR) */}
                            <div style={{ ...planCardStyle, backgroundColor: '#0f172a', color: 'white', border: '1px solid #1e293b', position: 'relative' }}>
                                <div style={{ position: 'absolute', top: '-11px', left: '20px', backgroundColor: '#a855f7', color: 'white', padding: '2px 10px', borderRadius: '8px', fontSize: '10px', fontWeight: '800', textTransform: 'uppercase' }}>
                                    Acesso Total
                                </div>
                                <div>
                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#c084fc', textTransform: 'uppercase', tracking: '0.05em', backgroundColor: 'rgba(168,85,247,0.15)', padding: '4px 10px', borderRadius: '8px' }}>
                                        Premium
                                    </span>
                                    <h3 style={{ fontSize: '24px', fontWeight: '800', color: 'white', margin: '15px 0 5px 0' }}>Premium Divulgador</h3>
                                    <p style={{ fontSize: '13px', color: '#94a3b8', margin: 0 }}>Para portais de notícias e grandes influencers.</p>

                                    <div style={{ margin: '25px 0', display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                        <span style={{ fontSize: '36px', fontWeight: '800', color: 'white' }}>R$ {prices.priceDivulgadorPremium.toFixed(2).replace('.', ',')}</span>
                                        <span style={{ fontSize: '14px', color: '#94a3b8' }}>/mês</span>
                                    </div>

                                    <hr style={{ border: 0, borderTop: '1px solid #1e293b', margin: '20px 0' }} />

                                    <ul style={planListStyle}>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> Texto, Imagens e Vídeos liberados</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> **Grupos e horários ilimitados**</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> **Instagram, WhatsApp e Telegram**</li>
                                        <li style={planListItemStyle}><Check size={16} style={{ color: '#c084fc' }} /> **Suporte Prioritário VIP**</li>
                                    </ul>
                                </div>

                                <button onClick={() => onNavigateAuth('register')} style={{ ...btnPlanStyle, backgroundColor: '#a855f7', color: 'white' }}>
                                    Assinar Premium
                                </button>
                            </div>

                        </div>
                    )}
                </div>
            </section>

            {/* SEÇÃO: CTA FINAL */}
            <section style={{
                padding: '80px 20px',
                background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
                color: 'white', textAlign: 'center'
            }}>
                <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                    <h2 style={{
                        fontSize: 'max(24px, 3.5vw)',
                        fontWeight: '900',
                        marginBottom: '15px',
                        color: '#ffffff',
                        lineHeight: '1.2'
                    }}>
                        Comece a Vender no <span style={{ color: '#ee4d2d' }}>Piloto Automático</span> Hoje!
                    </h2>
                    <p style={{ color: '#94a3b8', fontSize: 'max(14px, 1.1vw)', marginBottom: '35px', maxWidth: '600px', margin: '0 auto 35px auto', lineHeight: '1.6' }}>
                        Junte-se a milhares de afiliados que já economizam tempo e aumentam seus lucros diários usando o Anúncios App.
                    </p>
                    <button
                        onClick={() => onNavigateAuth('register')}
                        style={{
                            backgroundColor: '#ee4d2d', color: 'white', border: 'none',
                            borderRadius: '12px', padding: '18px 36px', fontSize: '16px',
                            fontWeight: '800', cursor: 'pointer', boxShadow: '0 10px 20px -5px rgba(238, 77, 45, 0.4)'
                        }}
                    >
                        Criar Minha Conta Grátis
                    </button>
                </div>
            </section>

            {/* FOOTER */}
            <footer style={{
                backgroundColor: '#0f172a', color: '#64748b', padding: '40px 20px',
                borderTop: '1px solid #1e293b', fontSize: '13px', textAlign: 'center'
            }}>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', alignItems: 'center', marginBottom: '20px' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}><Shield size={14} style={{ color: '#22c55e' }} /> Pagamentos criptografados de alta segurança</span>
                </div>
                <p style={{ margin: 0 }}>
                    © {new Date().getFullYear()} Anúncios App. Todos os direitos reservados. Desenvolvido por Vinícius Rodrigues
                    {" ("}
                    <a
                        href="https://www.linkedin.com/in/vinivcr"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: "#38bdf8",
                            textDecoration: "none",
                        }}
                    >
                        LinkedIn
                    </a>
                    {" | "}
                    <a
                        href="https://github.com/vinivcr"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: "#f1f5f9",
                            textDecoration: "none",
                        }}
                    >
                        GitHub
                    </a>
                    {")"}
                </p>
            </footer>

            {whatsappNumber && (
                <a
                    href={`https://wa.me/${whatsappNumber.replace(/\D/g, '')}?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20o%20Anúncios%20App!`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-float-btn"
                    style={{
                        position: 'fixed',
                        bottom: '30px',
                        right: '30px',
                        backgroundColor: '#25D366',
                        color: 'white',
                        borderRadius: '50px',
                        padding: '12px 24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        boxShadow: '0 8px 24px rgba(37, 211, 102, 0.4)',
                        textDecoration: 'none',
                        zIndex: 9999,
                        fontWeight: '700',
                        fontSize: '14px'
                    }}
                >
                    <WhatsappIcon size={22} color="white" />
                    <span>Precisa de ajuda?</span>
                </a>
            )}

        </div>
    );
};

// Estilos Reutilizáveis
const navLinkStyle = { background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: '14px', fontWeight: '700', transition: '0.2s' };
const stepCardStyle = { backgroundColor: '#f8fafc', padding: '30px', borderRadius: '20px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '15px', transition: '0.3s' };
const iconBgStyle = { width: '50px', height: '50px', borderRadius: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const stepTitleStyle = { fontSize: '18px', fontWeight: '800', color: '#0f172a', margin: 0 };
const stepTextStyle = { fontSize: '14px', color: '#64748b', margin: 0, lineHeight: '1.6' };
const featureCardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '20px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', transition: '0.3s' };
const reviewCardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '20px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.02)', display: 'flex', flexDirection: 'column', transition: '0.3s' };
const planCardStyle = { backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '24px', padding: '35px 30px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.02)' };
const planListStyle = { listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' };
const planListItemStyle = { display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px' };
const btnPlanStyle = { width: '100%', padding: '14px', borderRadius: '12px', border: 'none', fontWeight: '800', fontSize: '14px', cursor: 'pointer', marginTop: '35px', transition: '0.2s' };

export default LandingPage;
